<script>
  import In from "@/components/atoms/In";
  import Btn from "@/components/atoms/Btn";
  import Banner from "@/components/atoms/Banner";
  import Loading from "@/components/atoms/Loading";
  import SelectOption from '@/components/atoms/SelectOption.vue'
  export default {
    components: { In, Btn, Banner, Loading, SelectOption },
    data(){
      return {
        billing_options: [
          {
            display: 'Monthly',
            value: 'Monthly'
          },{
            display: 'Yearly',
            value: 'Yearly'
          }
        ],
        main_billing: 'Monthly',
      }
    },
    methods: {
      mailTo(){
        window.open('mailto:sales@quadrobee.com');
      },
      purchase(price){
        if(this.$store.get('auth/signed_in')){
          this.$store.dispatch('payment/subscribeUser', price)
        }else{
          this.$router.push('/signin?to='+this.$route.name)
        }
      }
    }
  }
</script>

<template>
  <div id="pricing-page">
    <Loading :loading="$store.get('payment/subscribingUser')" />
    <div class="pricing-container">
      <div class="pricing-title">
        Select a plan to get started
      </div>
      <div class="pricing-sub-title">
        Unlock the full capabilities of Quadrobee with Pro or Enterprise.
      </div>
      <div class="plan-container">
        <div class="plan special">
          <div class="plan-title">
            FREE
          </div>
          <template v-if="main_billing == 'Yearly'">
            <div class="plan-price">
              <span class="value">$0</span>
            </div>
            <div class="per-user">
              user/year
            </div>
          </template>
          <template v-else>
            <div class="plan-price">
              <span class="value">$0</span>
            </div>
            <div class="per-user">
              user/month
            </div>
          </template>

          <select-option :options="billing_options" @monthly="main_billing = 'Monthly'" @yearly="main_billing = 'Yearly'" location="right">
            <btn type="fill" size="small">Billed: {{main_billing}} <span class="fa fa-caret-down"></span></btn>
          </select-option>

          <div class="plan-benefits">
            <div class="includes">FREE INCLUDES</div>
            <div class="benefit">
              <span class="fa fa-check"/>Design Tools
            </div>
            <div class="benefit">
              <span class="fa fa-check"/>Mobile AR Viewer
            </div>
            <div class="benefit">
              <span class="fa fa-check"/>TSlot Aluminum
            </div>
            <div class="benefit">
              <span class="fa fa-check"/>Wood
            </div>
            <div class="benefit">
              <span class="fa fa-check"/>Primatives
            </div>
            <div class="benefit">
              <span class="fa fa-check"/>In-App Checkout
            </div>
          </div>
          <div class="purchase-button" @click="() => {}">
            Download
          </div>
        </div>
        <div class="plan main">
          <div class="plan-title">
            PRO
          </div>
          <template v-if="main_billing == 'Yearly'">
            <div class="plan-price">
              <span class="value">$800</span>
            </div>
            <div class="per-user">
              user/year
            </div>
          </template>
          <template v-else>
            <div class="plan-price">
              <span class="value">$90</span>
            </div>
            <div class="per-user">
              user/month
            </div>
          </template>

          <select-option :options="billing_options" @monthly="main_billing = 'Monthly'" @yearly="main_billing = 'Yearly'" location="right">
            <btn type="fill" size="small">Billed: {{main_billing}} <span class="fa fa-caret-down"></span></btn>
          </select-option>

          <div class="plan-benefits">
            <div class="includes">EVERYTHING IN FREE +</div>
            <div class="benefit">
              <span class="fa fa-check"/>Exporting
            </div>
            <div class="benefit">
              <span class="fa fa-check"/>Importing
            </div>
            <div class="benefit">
              <span class="fa fa-check"/>Sharing
            </div>
            <div class="benefit">
              <span class="fa fa-check"/>Export Bill of Materials
            </div>
            <div class="benefit">
              <span class="fa fa-check"/>Priority Support
            </div>
          </div>
          <div class="purchase-button" @click="purchase(main_billing == 'Yearly' ? 'price_1Kaj8aH6pG6cvCgpkvlIL1R0' : 'price_1Kaj8KH6pG6cvCgptUcYlKKT')">
            Purchase
          </div>
        </div>
        <div class="plan custom">
          <div class="plan-title">
            ENTERPRISE
          </div>
          <template v-if="main_billing == 'Yearly'">
            <div class="plan-price">
              <span class="value">$1700</span>
            </div>
            <div class="per-user">
              user/year
            </div>
          </template>
          <template v-else>
            <div class="plan-price">
              <span class="value">$180</span>
            </div>
            <div class="per-user">
              user/month
            </div>
          </template>
          <select-option :options="billing_options" @monthly="main_billing = 'Monthly'" @yearly="main_billing = 'Yearly'" location="right">
            <btn type="fill" size="small">Billed: {{main_billing}} <span class="fa fa-caret-down"></span></btn>
          </select-option>
          <div class="plan-benefits">
            <div class="includes">EVERYTHING IN PRO +</div>
            <div class="benefit">
              <span class="fa fa-check"/>Supplier Integration
            </div>
            <div class="benefit">
              <span class="fa fa-check"/>Custom Parts
            </div>
            <div class="benefit">
              <span class="fa fa-check"/>Custom BOM
            </div>
            <div class="benefit">
              <span class="fa fa-check"/>Design Reviews
            </div>
            <div class="benefit">
              <span class="fa fa-check"/>Assembly Instructions
            </div>
          </div>
          <div class="purchase-button" @click="mailTo()">
            Contact Sales
          </div>
        </div>
      </div>
    </div>
    <div class="pricing-table">
      <div class="pricing-title">
        Compare our plans
      </div>
      <table>
        <tr>
          <td class="section-header"></td>
          <td class="section-header">FREE</td>
          <td class="section-header">PRO</td>
          <td class="section-header">ENTERPRISE</td>
        </tr>
        <tr>
          <td class="section-header" colspan="4">Design Tools</td>
        </tr>
        <tr>
          <td>Part Assembly</td>
          <td>✅</td>
          <td>✅</td>
          <td>✅</td>
        </tr>
        <tr>
          <td>Part Extruding</td>
          <td>✅</td>
          <td>✅</td>
          <td>✅</td>
        </tr>
        <tr>
          <td>Measuring</td>
          <td>✅</td>
          <td>✅</td>
          <td>✅</td>
        </tr>
        <tr>
          <td>Mixed Reality</td>
          <td>✅</td>
          <td>✅</td>
          <td>✅</td>
        </tr>
        <tr>
          <td>Mobile AR Viewer</td>
          <td>✅</td>
          <td>✅</td>
          <td>✅</td>
        </tr>
        <tr>
          <td>Hand Tracking</td>
          <td>🟨</td>
          <td>🟨</td>
          <td>🟨</td>
        </tr>
        <tr>
          <td class="section-header" colspan="4">Export</td>
        </tr>
        <tr>
          <td>STEP</td>
          <td>-</td>
          <td>✅</td>
          <td>✅</td>
        </tr>
        <tr>
          <td>GLB</td>
          <td>-</td>
          <td>✅</td>
          <td>✅</td>
        </tr>
        <tr>
          <td>FBX</td>
          <td>-</td>
          <td>✅</td>
          <td>✅</td>
        </tr>
        <tr>
          <td>OBJ</td>
          <td>-</td>
          <td>✅</td>
          <td>✅</td>
        </tr>
        <tr>
          <td>DXF</td>
          <td>-</td>
          <td>✅</td>
          <td>✅</td>
        </tr>
        <tr>
          <td>IFC</td>
          <td>-</td>
          <td>✅</td>
          <td>✅</td>
        </tr>
        <tr>
          <td>IGES</td>
          <td>-</td>
          <td>✅</td>
          <td>✅</td>
        </tr>
        <tr>
          <td>U3D</td>
          <td>-</td>
          <td>✅</td>
          <td>✅</td>
        </tr>
        <tr>
          <td>USD</td>
          <td>-</td>
          <td>✅</td>
          <td>✅</td>
        </tr>
        <tr>
          <td class="section-header" colspan="4">Import</td>
        </tr>
        <tr>
          <td>STEP</td>
          <td>-</td>
          <td>🟨</td>
          <td>🟨</td>
        </tr>
        <tr>
          <td>GLB</td>
          <td>-</td>
          <td>🟨</td>
          <td>🟨</td>
        </tr>
        <tr>
          <td>FBX</td>
          <td>-</td>
          <td>🟨</td>
          <td>🟨</td>
        </tr>
        <tr>
          <td>OBJ</td>
          <td>-</td>
          <td>🟨</td>
          <td>🟨</td>
        </tr>
        <tr>
          <td class="section-header" colspan="4">Sharing & Collaboration</td>
        </tr>
        <tr>
          <td>Share Mobile Augmented Reality Links</td>
          <td>-</td>
          <td>✅</td>
          <td>✅</td>
        </tr>
        <tr>
          <td>Share 3D Project View Links</td>
          <td>-</td>
          <td>✅</td>
          <td>✅</td>
        </tr>
        <tr>
          <td class="section-header" colspan="4">Libraries</td>
        </tr>
        <tr>
          <td>Primitives</td>
          <td>✅</td>
          <td>✅</td>
          <td>✅</td>
        </tr>
        <tr>
          <td>TSlot Aluminum</td>
          <td>✅</td>
          <td>✅</td>
          <td>✅</td>
        </tr>
        <tr>
          <td>Wood</td>
          <td>✅</td>
          <td>✅</td>
          <td>✅</td>
        </tr>
        <tr>
          <td>Custom Parts (50)</td>
          <td>-</td>
          <td>-</td>
          <td>✅</td>
        </tr>
        <tr>
          <td class="section-header" colspan="4">Platforms</td>
        </tr>
        <tr>
          <td>Meta Quest Pro</td>
          <td>✅</td>
          <td>✅</td>
          <td>✅</td>
        </tr>
        <tr>
          <td>Meta Quest 3</td>
          <td>✅</td>
          <td>✅</td>
          <td>✅</td>
        </tr>
        <tr>
          <td>Meta Quest 2</td>
          <td>✅</td>
          <td>✅</td>
          <td>✅</td>
        </tr>
        <tr>
          <td>Apple Vision Pro</td>
          <td>-</td>
          <td>🟨</td>
          <td>🟨</td>
        </tr>
        <tr>
          <td class="section-header" colspan="4">Ordering</td>
        </tr>
        <tr>
          <td>In-App Checkout</td>
          <td>✅</td>
          <td>✅</td>
          <td>✅</td>
        </tr>
        <tr>
          <td>Export BOM</td>
          <td>-</td>
          <td>✅</td>
          <td>✅</td>
        </tr>
        <tr>
          <td>Custom BOM</td>
          <td>-</td>
          <td>-</td>
          <td>✅</td>
        </tr>
        <tr>
          <td>Supplier Integration</td>
          <td>-</td>
          <td>-</td>
          <td>✅</td>
        </tr>
        <tr>
          <td class="section-header" colspan="4">Assembly</td>
        </tr>
        <tr>
          <td>Part Locator</td>
          <td>✅</td>
          <td>✅</td>
          <td>✅</td>
        </tr>
        <tr>
          <td>Assembly Instructions</td>
          <td>-</td>
          <td>-</td>
          <td>🟨</td>
        </tr>
        <tr>
          <td class="section-header" colspan="4">Support</td>
        </tr>
        <tr>
          <td>Documentation & Tutorials</td>
          <td>🟨</td>
          <td>🟨</td>
          <td>🟨</td>
        </tr>
        <tr>
          <td>Email support</td>
          <td>✅</td>
          <td>✅</td>
          <td>✅</td>
        </tr>
        <tr>
          <td>Priority support</td>
          <td>-</td>
          <td>✅</td>
          <td>✅</td>
        </tr>
        <tr>
          <td>Design Reviews</td>
          <td>-</td>
          <td>-</td>
          <td>✅</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<style lang="scss">
@import "~@/styles/constants";
#pricing-page { 
  background: $black_1;
  color: $w;
  min-height: 100%;
	.pricing-container { 
    display: flex;
    flex-direction: column;
    align-items: center;
		.pricing-title { 
      padding-top: 5rem;
      font-size: 2rem;
      padding-bottom: 1rem;
		}
    .pricing-sub-title{
      font-size: 1.25rem;
      padding-bottom: 4rem;
    }
		.plan-container { 
      display: flex;
      align-items: stretch;
      justify-content: center;
      flex-wrap: wrap;
      margin-bottom: 4rem;
      padding: 0rem 2rem;
			.plan {   
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 24rem;
        box-shadow: $z_depth_3;
        z-index: 1;
        position: relative;
        border-radius: 0.5rem;
        margin: 1rem;
        background-color: $black_2;
				.plan-title { 
          padding-top: 2rem;
          padding-bottom: 1rem;
          font-size: 1.5rem;
          font-weight: 700;
				}

				.plan-price { 
          margin-bottom: 1rem;
					.value { 
            font-weight: 700;
            font-size: 3rem;
					}
					.interval { 
            font-size: 1.5rem;
					}
				}
				.per-user { 
          font-size: 1.25rem;
          margin-bottom: 0.5rem;
				}

        .select-container{
          margin-bottom: 2rem;
          .card-options{
            .button{
              .fa{
                margin-right: 0rem;
                margin-left: 0.5rem;
              }
            }
          }
          // .options-container{
          //   background-color: #FFF;
          //   .option{
          //     &:hover, &.hover{
          //       cursor: pointer;
          //       background-color: #EEE;
          //     }
          //     &:active{
          //       color: #666;
          //       background-color: #DDD;
          //     }
          //   }
          // }
        }

				.plan-benefits { 
          font-weight: 500;
          border-top: 1px solid $black_4;
          width: 100%;
          padding: 2rem 2rem 1rem 2rem;
          flex: 1;
          .includes{
            font-weight: 600;
            color: $w_1;
            text-align: center;
            margin-bottom: 1rem;
            font-size: 1.25rem;
          }
					.benefit { 
            display: flex;
            align-items: center;
            padding: 0.5rem 0rem;
            font-size: 1.25rem;
						.fa { 
              font-size: 1.25rem;
              margin-right: 1rem;
              color: rgb(30, 201, 121);
						}
					}
				}

				.purchase-button { 
          justify-self: end;
          font-size: 1.25rem;
          color: #FFF;
          background-color: $p; //rgba(255,255,255,0.1);
          display: flex;
          align-items: center;
          justify-content: center;
          width: calc(100% - 4rem);
          padding: 1rem 1.5rem;
          margin: 1.5rem 0.5rem;
          border-radius: 0.25rem;
          &:hover, &.hover{
            cursor: pointer;
            background-color: #bf7ff7;
          }
          &:active{
            background-color: $p1;
          }
				}
			}
		}
	}
  .pricing-table{
    background-color: $black_2;
    padding: 4rem 3rem;
    padding-bottom: 4rem;
    .pricing-title{
      width: 100%;
      text-align: center;
      font-size: 2rem;
      margin-bottom: 2rem;
    }
    .section-header{
      font-size: 1.5rem;
      padding-top: 2rem;
      font-weight: 600;
    }
    table{
      width: 100%;
      tr{
        td{
          font-weight: 500;
          padding: 1rem;
          font-size: 1.25rem;
          border-bottom: 1px solid $black_3;
        }
      }
    }
  }
}
</style>